var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "root" },
    [
      _c(
        "div",
        { staticClass: "flex flex-wrap items-center justify-end mural-head" },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-wrap items-center",
              staticStyle: { gap: ".6rem" },
            },
            [
              _c("span", { staticClass: "mural-head__range" }, [
                _vm._v(_vm._s(_vm.rangeLabel)),
              ]),
              _c(
                "b-button-group",
                { attrs: { size: "sm" } },
                _vm._l(_vm.periodOptions, function (option) {
                  return _c(
                    "b-button",
                    {
                      key: option.value,
                      attrs: {
                        variant:
                          _vm.period === option.value
                            ? "primary"
                            : "outline-primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setPeriod(option.value)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(option.label) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm.period === "custom"
        ? _c(
            "div",
            {
              staticClass: "flex flex-wrap items-center justify-end mb-1",
              staticStyle: { gap: ".6rem" },
            },
            [
              _c("b-form-input", {
                staticClass: "mural-date",
                attrs: { type: "date", size: "sm" },
                model: {
                  value: _vm.customFrom,
                  callback: function ($$v) {
                    _vm.customFrom = $$v
                  },
                  expression: "customFrom",
                },
              }),
              _c("small", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("mural.period.to"))),
              ]),
              _c("b-form-input", {
                staticClass: "mural-date",
                attrs: { type: "date", size: "sm" },
                model: {
                  value: _vm.customTo,
                  callback: function ($$v) {
                    _vm.customTo = $$v
                  },
                  expression: "customTo",
                },
              }),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary", size: "sm" },
                  on: { click: _vm.loadSummary },
                },
                [_vm._v(_vm._s(_vm.$t("mural.period.apply")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showStripeWarning
        ? _c(
            "b-alert",
            {
              staticClass: "p-1 mb-1",
              attrs: { show: "", variant: "warning" },
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "AlertTriangleIcon" },
              }),
              _vm._v(
                " Sua conta de recebimento (Stripe) ainda não está conectada — enquanto isso, as vendas pelo Stripe ficam integralmente na conta da plataforma. "
              ),
              _c(
                "router-link",
                {
                  staticClass: "font-weight-bold",
                  attrs: { to: "/my-account" },
                },
                [_vm._v("Conectar agora")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.kycStatus === "RJ"
        ? _c(
            "b-alert",
            { staticClass: "p-1 mb-1", attrs: { show: "", variant: "danger" } },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "XCircleIcon" },
              }),
              _vm._v(" Seu cadastro foi recusado pela equipe Hubee"),
              _vm.kycNotes
                ? _c("span", [
                    _vm._v(": "),
                    _c("em", [_vm._v(_vm._s(_vm.kycNotes))]),
                  ])
                : _vm._e(),
              _vm._v(". "),
              _vm.checklistPendente.length
                ? [
                    _vm._v(
                      " Falta " +
                        _vm._s(_vm.checklistPendente.join(", ")) +
                        ". "
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "font-weight-bold",
                        attrs: { to: _vm.completeRegistrationPath },
                      },
                      [_vm._v("Corrigir cadastro")]
                    ),
                  ]
                : [
                    _c(
                      "router-link",
                      {
                        staticClass: "font-weight-bold",
                        attrs: { to: _vm.completeRegistrationPath },
                      },
                      [_vm._v("Revisar cadastro")]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: {
                          size: "sm",
                          variant: "danger",
                          disabled: _vm.resubmitting,
                        },
                        on: { click: _vm.resubmitKyc },
                      },
                      [_vm._v(" Reenviar para análise ")]
                    ),
                  ],
            ],
            2
          )
        : _vm.checklistPendente.length
        ? _c(
            "b-alert",
            {
              staticClass: "p-1 mb-1",
              attrs: { show: "", variant: "warning" },
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "AlertTriangleIcon" },
              }),
              _vm._v(
                " Seu cadastro ainda não está completo — falta " +
                  _vm._s(_vm.checklistPendente.join(", ")) +
                  ". "
              ),
              _c(
                "router-link",
                {
                  staticClass: "font-weight-bold",
                  attrs: { to: _vm.completeRegistrationPath },
                },
                [_vm._v("Completar cadastro")]
              ),
            ],
            1
          )
        : _vm.kycStatus === "PE" && _vm.entityStatus !== "AC"
        ? _c(
            "b-alert",
            { staticClass: "p-1 mb-1", attrs: { show: "", variant: "info" } },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "ClockIcon" },
              }),
              _vm._v(
                " Seu cadastro está completo e em análise pela equipe Hubee — você recebe a resposta por e-mail. "
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "dashboard",
              expression: "'dashboard'",
            },
          ],
        },
        [
          _vm.summary
            ? _c("mural-kpi-row", {
                attrs: {
                  summary: _vm.summary,
                  "money-hidden": _vm.moneyHidden,
                  period: _vm.period,
                  scroll: _vm.isNarrow,
                },
                on: { "toggle-values": _vm.toggleMoneyHidden },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "mural-layout",
              class: { "mural-layout--stacked": _vm.isNarrow },
            },
            [
              _c("mural-agenda", {
                attrs: {
                  days: _vm.agenda.days,
                  classes: _vm.agenda.classes,
                  view: _vm.view,
                  anchor: _vm.anchor,
                },
                on: {
                  "update:view": _vm.onViewChange,
                  "update:anchor": _vm.onAnchorChange,
                  select: _vm.openOccurrence,
                },
              }),
              _c(
                "div",
                {
                  staticClass: "flex flex-column",
                  staticStyle: { gap: "1.25rem", "min-width": "0" },
                },
                [
                  _c("mural-upcoming", {
                    attrs: {
                      days: _vm.agenda.days,
                      classes: _vm.agenda.classes,
                    },
                    on: {
                      select: _vm.openOccurrence,
                      "go-agenda": _vm.goToday,
                    },
                  }),
                  _vm.summary && _vm.summary.sales
                    ? _c("mural-sales", {
                        attrs: {
                          sales: _vm.summary.sales,
                          total: _vm.summary.sales_total,
                          "period-label": _vm.periodChip,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.selected
        ? _c("mural-occurrence-drawer", {
            attrs: {
              slot: _vm.selected.slot,
              date: _vm.selected.date,
              lesson: _vm.selected.lesson,
            },
            on: {
              close: function ($event) {
                _vm.selected = null
              },
              action: _vm.onAction,
            },
            slot: _vm.selected.slot,
          })
        : _vm._e(),
      _c("mural-action-modal", {
        ref: "actionModal",
        on: { saved: _vm.onActionSaved },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }